// Display the star ratings at top of the products
var reviewInterval;

function reviewsList(){
    if(document.querySelectorAll('.product-form .jdgm-prev-badge').length > 0 ) {
      var rate = document.querySelector('.product-form .jdgm-prev-badge').dataset.averageRating
        var rateN = parseInt(rate);
      if( rateN <= 4 ) {
        document.querySelector('body').classList.add('hide-review');
      }
      clearInterval(reviewInterval);
    }
}

if(document.querySelectorAll('.product-form .jdgm-prev-badge').length > 0){
  reviewInterval = setInterval(reviewsList, 100);
}